// extracted by mini-css-extract-plugin
module.exports = {"list":"suggestedList_list__doLv1","paddedImage":"suggestedList_paddedImage__iOryx"};